import React from "react";
import { Route, Navigate } from "react-router-dom";
import { all_routes } from "./all_routes";

import Signin from "../feature-module/pages/login/signin";
import Error404 from "../feature-module/pages/errorpages/error404";
import Error500 from "../feature-module/pages/errorpages/error500";
import Undermaintainence from "../feature-module/pages/undermaintainence";

import PrizeList from "../feature-module/spinwheel/prize/prizelist";
import AddPrize from "../feature-module/spinwheel/prize/addprize";
import EditPrize from "../feature-module/spinwheel/prize/editprize";
import PrizeDetail from "../feature-module/spinwheel/prize/prizedetail";
import TierList from "../feature-module/spinwheel/tier/tierlist";
import AddTier from "../feature-module/spinwheel/tier/addtier";
import EditTier from "../feature-module/spinwheel/tier/edittier";
import TierDetail from "../feature-module/spinwheel/tier/tierdetail";
import GroupTierList from "../feature-module/spinwheel/group-tier/grouptierlist";
import AddGroupTier from "../feature-module/spinwheel/group-tier/addgrouptier";
import EditGroupTier from "../feature-module/spinwheel/group-tier/editgrouptier";
import GroupTierDetail from "../feature-module/spinwheel/group-tier/grouptierdetail";
import SpinConfig from "../feature-module/spin/spinconfig";
import TokenConfig from "../feature-module/token/tokenconfig";
import SpinHistory from "../feature-module/spinwheel/spinhistory";
import RankList from "../feature-module/rank/ranklist";
import UserList from "../feature-module/user/userlist";
import AddUser from "../feature-module/user/adduser";
import EditUser from "../feature-module/user/edituser";

const routes = all_routes;

export const publicRoutes = [
  {
    id: 2,
    path: routes.prizeList,
    name: "prizeList",
    element: <PrizeList />,
    route: Route,
  },
  {
    id: 3,
    path: routes.addPrize,
    name: "addPrize",
    element: <AddPrize />,
    route: Route,
  },
  {
    id: 4,
    path: routes.editPrize,
    name: "editPrize",
    element: <EditPrize />,
    route: Route,
  },
  {
    id: 5,
    path: routes.prizeDetails,
    name: "prizeDetails",
    element: <PrizeDetail />,
    route: Route,
  },
  {
    id: 6,
    path: routes.tierList,
    name: "tierList",
    element: <TierList />,
    route: Route,
  },
  {
    id: 7,
    path: routes.addTier,
    name: "addTier",
    element: <AddTier />,
    route: Route,
  },
  {
    id: 8,
    path: routes.editTier,
    name: "editTier",
    element: <EditTier />,
    route: Route,
  },
  {
    id: 9,
    path: routes.tierDetails,
    name: "tierDetails",
    element: <TierDetail />,
    route: Route,
  },
  {
    id: 10,
    path: routes.groupTierList,
    name: "groupTierList",
    element: <GroupTierList />,
    route: Route,
  },
  {
    id: 11,
    path: routes.addGroupTier,
    name: "addGroupTier",
    element: <AddGroupTier />,
    route: Route,
  },
  {
    id: 12,
    path: routes.editGroupTier,
    name: "editGroupTier",
    element: <EditGroupTier />,
    route: Route,
  },
  {
    id: 13,
    path: routes.groupTierDetails,
    name: "groupTierDetails",
    element: <GroupTierDetail />,
    route: Route,
  },
  {
    id: 14,
    path: routes.spinConfig,
    name: "spinConfig",
    element: <SpinConfig />,
    route: Route,
  },
  {
    id: 15,
    path: routes.tokenConfig,
    name: "tokenConfig",
    element: <TokenConfig />,
    route: Route,
  },
  {
    id: 16,
    path: routes.spinHistory,
    name: "spinHistory",
    element: <SpinHistory />,
    route: Route,
  },
  {
    id: 17,
    path: routes.rankList,
    name: "rankList",
    element: <RankList />,
    route: Route,
  },
  {
    id: 18,
    path: routes.userList,
    name: "userList",
    element: <UserList />,
    route: Route,
  },
  {
    id: 19,
    path: routes.addUser,
    name: "addUser",
    element: <AddUser />,
    route: Route,
  },
  {
    id: 20,
    path: routes.editUser,
    name: "editUser",
    element: <EditUser />,
    route: Route,
  },
  {
    id: 101,
    path: "*",
    name: "NotFound",
    element: <Navigate to="/" />,
    route: Route,
  },
  {
    id: 102,
    path: '/',
    name: 'Root',
    element: <Navigate to="/signin" />,
    route: Route,
  },
];

export const pagesRoute = [
  {
    id: 1,
    path: routes.signin,
    name: "signin",
    element: <Signin />,
    route: Route,
  },
  {
    id: 2,
    path: routes.error404,
    name: "error404",
    element: <Error404 />,
    route: Route,
  },
  {
    id: 3,
    path: routes.error500,
    name: "error500",
    element: <Error500 />,
    route: Route,
  },
  {
    id: 4,
    path: routes.undermaintenance,
    name: "undermaintenance",
    element: <Undermaintainence />,
    route: Route,
  },
];
